import cornerstone from 'cornerstone-core';

/**
 * cornerstone creates the viewport canvas with `desynchronized: true`
 * (low-latency front-buffer rendering). On some Android devices the canvas then
 * stops presenting new frames while scrolling a stack: the old image stays on
 * screen until a resize (e.g. toggling fullscreen) recreates the surface.
 *
 * The first `getContext` call on a canvas fixes its attributes, so creating a
 * regular context here, before cornerstone's first draw on the next animation
 * frame, makes cornerstone reuse it.
 */
const disableDesynchronizedCanvas = () => {
  cornerstone.events.addEventListener(
    cornerstone.EVENTS.ELEMENT_ENABLED,
    event => {
      const { canvas } = event.detail;
      if (canvas) {
        canvas.getContext('2d');
      }
    }
  );
};

export default disableDesynchronizedCanvas;
